import './polyfills';
import React from 'react';
import ReactDOM from "react-dom/client";
import './index.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "./classic/assets/css/animate.min.css";
import "./classic/assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0";
import "@fortawesome/fontawesome-free/css/all.min.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { bootstrapNetworkHealth, bootstrapUserTracer, userTracer } from "./logging";

bootstrapUserTracer();
bootstrapNetworkHealth();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals((metric) => {
  userTracer.captureWebVital(metric);
});
